import type { QueryClient } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

import type { Organization } from "@/features/organizations/models/organization";
import { organizationsQueryKeys } from "@/features/organizations/queries/organizations-query-keys";
import { ApiResponse } from "@/models/api-response";

export function findOrganizationInListCache(
  queryClient: QueryClient,
  customerId: number,
  organizationId: string,
): Organization | undefined {
  const data = queryClient.getQueryData<ApiResponse<Organization[]>>(organizationsQueryKeys.list(customerId));
  return data?.data?.find((organization) => organization.organizationId === organizationId);
}

export function useOrganizationFromListCache(
  customerId: number | undefined,
  organizationId: string | undefined,
): Organization | undefined {
  const queryClient = useQueryClient();

  return useMemo(() => {
    if (!customerId || !organizationId) {
      return undefined;
    }

    return findOrganizationInListCache(queryClient, customerId, organizationId);
  }, [queryClient, customerId, organizationId]);
}
